module.exports = __webpack_public_path__ + "img/cn.90cfb864.svg";